export default __webpack_public_path__ + "static/media/Service.89026f88.svg";